<template>
  <v-container style="padding: 0;">
    <v-dialog v-model="hideShow" width="960px" persistent content-class="record-detail-dialog">
      <v-card class="rd-shell">
        <header class="rd-header">
          <div class="rd-heading">
            <span class="rd-emblem"><v-icon size="26" color="#d9363e">mdi-calendar-text-outline</v-icon></span>
            <div class="rd-heading-text">
              <div class="rd-title-row">
                <h2>{{record ? record.courseName : '课程详情'}}</h2>
                <span v-if="record" class="rd-status" :class="'rd-status-'+record.status">{{statusName(record.status)}}</span>
              </div>
              <p>课程详情<span v-if="record && record.className"> · {{record.className}}</span></p>
            </div>
          </div>
          <v-btn icon aria-label="关闭课程详情" @click="cancel"><v-icon>mdi-close</v-icon></v-btn>
        </header>

        <div v-if="record" class="rd-toolbar" aria-label="课次操作">
          <v-btn class="rd-primary" depressed color="#d9363e" :disabled="record.status !=='1'" @click="toShowApprove"><v-icon left small>mdi-check-circle-outline</v-icon>核销</v-btn>
          <v-btn outlined :disabled="record.status !=='1'" @click="toShowUpdate"><v-icon left small>mdi-pencil-outline</v-icon>修改</v-btn>
          <v-btn outlined :disabled="record.status !=='1'" @click="delayRecord">顺延</v-btn>
          <v-btn outlined :disabled="record.status !=='3'" @click="undoDelayRecord">撤销顺延</v-btn>
          <v-btn outlined :disabled="record.status !=='2'" @click="showCancelApprove">撤销核销</v-btn>
          <v-btn v-if="record.shopAllowBook=='1' && record.status == '1'" outlined @click="toShowBook">约课设置</v-btn>
          <v-btn class="rd-delete" text color="#d9363e" :disabled="record.status !=='1'" @click="frozenRecord"><v-icon left small>mdi-trash-can-outline</v-icon>删除</v-btn>
        </div>

        <v-card-text class="rd-scroll">
          <template v-if="record">
            <section class="rd-lesson" aria-label="上课安排">
              <div class="rd-when">
                <span class="rd-label">上课时间</span>
                <strong>{{record.timeFrom}}<span> – </span>{{record.timeTo}}</strong>
                <time>{{record.classDate}}</time>
              </div>
              <dl class="rd-facts">
                <div><dt>任课老师</dt><dd>{{record.teacherName || '—'}}</dd></div>
                <div><dt>上课教室</dt><dd>{{record.roomName || '—'}}</dd></div>
                <div><dt>班级名称</dt><dd>{{record.className || '—'}}</dd></div>
                <div><dt>扣费方式</dt><dd><span v-if="record.approveConsumeType=='1'">按课时核销</span><span v-if="record.approveConsumeType=='2'">按金额核销</span></dd></div>
              </dl>
            </section>

            <section v-if="record.isAllowBook=='1'" class="rd-book-summary" aria-label="约课情况">
              <span class="rd-book-tag"><v-icon small color="#238267">mdi-calendar-check-outline</v-icon>约课课程</span>
              <span>最大约课人数 <strong>{{record.maxBookQty}}</strong></span>
              <span>已约课人数 <strong>{{record.bookCount}}</strong></span>
            </section>

            <section v-if="record.status =='2'" class="rd-approval-summary" aria-label="核销汇总">
              <div><span>应 / 实 / 假 / 旷</span><strong>{{record.unionCount}}</strong></div>
              <div><span>核销扣除</span><strong v-if="record.approveConsumeType ==='2'">{{record.totalReduceFee}}<small> 元</small></strong><strong v-else>{{record.totalReduceQty}}<small> 课时</small></strong></div>
              <div><span>消课收入</span><strong>{{record.totalRevenue}}<small> 元</small></strong></div>
            </section>

            <section v-if="record.status =='1' && record.classStudentList" class="rd-section">
              <div class="rd-section-title"><h3>班级学员 <span>{{record.classStudentList.length}} 人</span></h3></div>
              <div class="rd-students">
                <article v-for="(item,index) in record.classStudentList" :key="item.id || index" class="rd-student">
                  <div class="rd-student-heading"><span class="rd-avatar">{{(item.studentName || '学').slice(0,1)}}</span><strong>{{item.studentName}}</strong></div>
                  <dl class="rd-student-facts"><div><dt>入班日期</dt><dd>{{item.joinDate || '—'}}</dd></div><div v-if="record.approveConsumeType=='2'"><dt>消课价格</dt><dd>{{item.classPrice}} 元 / 课时</dd></div></dl>
                </article>
              </div>
              <div v-if="record.classStudentList.length==0" class="rd-empty"><v-icon size="28" color="#9aa8b9">mdi-account-group-outline</v-icon><p>暂无班级成员</p></div>
            </section>

            <section v-if="record.status =='1' && record.extraStudentList && record.extraStudentList.length > 0" class="rd-section">
              <div class="rd-section-title"><h3>插班补课学员 <span>{{record.extraStudentList.length}} 人</span></h3></div>
              <div class="rd-students">
                <article v-for="(item,index) in record.extraStudentList" :key="item.id || index" class="rd-student">
                  <div class="rd-student-heading"><span class="rd-avatar">{{(item.studentName || '学').slice(0,1)}}</span><strong>{{item.studentName}}</strong><v-btn icon small color="#8895a7" :aria-label="'移除补课学员'+item.studentName" @click="removeExtraStudent(item)"><v-icon size="19">mdi-close</v-icon></v-btn></div>
                  <dl class="rd-student-facts"><div><dt>缺课日期</dt><dd>{{item.missClassDate || '—'}}</dd></div><div v-if="record.approveConsumeType=='2'"><dt>消课价格</dt><dd>{{item.recordPrice}} 元 / 课时</dd></div></dl>
                </article>
              </div>
            </section>

            <section v-if="record.isAllowBook =='1' && record.status =='1' && record.bookStudentList" class="rd-section">
              <div class="rd-section-title"><h3>已约课学员 <span>{{record.bookStudentList.length}} 人</span></h3><v-btn outlined small color="#d9363e" @click="showAddBookStudent"><v-icon small left>mdi-plus</v-icon>添加约课学员</v-btn></div>
              <div class="rd-students">
                <article v-for="(item,index) in record.bookStudentList" :key="item.id || index" class="rd-student">
                  <div class="rd-student-heading"><span class="rd-avatar">{{(item.studentName || '学').slice(0,1)}}</span><strong>{{item.studentName}}</strong><v-btn icon small color="#8895a7" :aria-label="'移除约课学员'+item.studentName" @click="removeBookStudent(item)"><v-icon size="19">mdi-close</v-icon></v-btn></div>
                  <button type="button" class="rd-book-detail" :aria-label="'查看'+item.studentName+'约课信息'" @click="showUpdateBookPrice(item)">
                    <dl class="rd-student-facts"><div><dt>约课时间</dt><dd>{{item.createAt || '—'}}</dd></div><div v-if="record.approveConsumeType=='2'"><dt>消课价格</dt><dd>{{item.recordPrice}} 元 / 课时</dd></div></dl>
                    <span v-if="record.approveConsumeType=='2'" class="rd-card-action">修改价格<v-icon size="14">mdi-chevron-right</v-icon></span>
                  </button>
                </article>
              </div>
              <div v-if="record.bookStudentList.length==0" class="rd-empty"><v-icon size="28" color="#9aa8b9">mdi-calendar-account-outline</v-icon><p>暂无约课成员</p></div>
            </section>

            <section v-if="record.status =='2' && record.approvedDetailList" class="rd-section">
              <div class="rd-section-title"><h3>核销明细 <span>{{record.approvedDetailList.length}} 人</span></h3><span class="rd-hint">点击学员查看或修改核销明细</span></div>
              <div class="rd-students">
                <button v-for="(item,index) in record.approvedDetailList" :key="item.id || index" type="button" class="rd-student rd-student-button" @click="showUpdateRecord(item)">
                  <span class="rd-student-heading"><span class="rd-avatar">{{(item.studentName || '学').slice(0,1)}}</span><strong>{{item.studentName}}</strong><span v-if="item.status == '1'" class="rd-attendance rd-attendance-present">到课</span><span v-if="item.status == '2'" class="rd-attendance rd-attendance-leave">请假</span><span v-if="item.status == '3'" class="rd-attendance">旷课</span></span>
                  <span class="rd-approved-deduction"><span v-if="item.consumeType ==='1'">扣课时 <strong>{{item.reduceQty}}</strong> 课时</span><span v-if="item.consumeType ==='2'">扣金额 <strong>{{item.reduceAmount}}</strong> 元</span><span v-if="item.studentType=='2'" class="rd-mini-tag">约课</span><span v-if="item.studentType=='3'" class="rd-mini-tag rd-mini-tag-extra">补课</span><v-icon size="16">mdi-chevron-right</v-icon></span>
                </button>
              </div>
              <div v-if="record.approvedDetailList.length==0" class="rd-empty"><p>暂无核销明细</p></div>
            </section>
          </template>
        </v-card-text>
      </v-card>
    </v-dialog>


		<!-- 核销组件 -->
		<approveRecord :show="approveCom.show" :recordId="approveCom.recordId" @cancel="approveCom.show=false" @success="approveSuccess"></approveRecord>
		<!-- 修改课次组件 -->
		<updateRecord :show="updateCom.show" :record="updateCom.record" @cancel="updateCom.show=false" @success="updateSuccess"></updateRecord>
		<!-- 撤销核销组件 -->
		<cancelApproveRecord :show="cancelApprove.show" :recordId="cancelApprove.recordId" @cancel="cancelApprove.show=false" @success="cancelApproveSuccess"></cancelApproveRecord>
		<!-- 约课设置组件 -->
		<recordBookSetting :show="bookCom.show" :record="bookCom.record" @cancel="bookCom.show=false" @success="bookSetSuccess"></recordBookSetting>
		<!-- 添加约课学员 -->
		<recordBookAddStudent :show="addBookStudent.show" :record="addBookStudent.record" @cancel="addBookStudent.show=false" @success="addBookStudentSuccess"></recordBookAddStudent>
		<!-- 修改约课学员消课价格 -->
		<updateRecordBookPrice :show="updateBookPrice.show" :bookStudent="updateBookPrice.bookStudent" @cancel="updateBookPrice.show=false" @success="updateBookPriceSuccess"></updateRecordBookPrice>
		<!-- 修改核销明细 -->
		<updateApprovedRecordDetail :show="updateRecordDialog.show" :recordDetail="updateRecordDialog.recordDetail" @cancel="updateRecordDialog.show=false" @success="updateRecordSuccess"></updateApprovedRecordDetail>
		
	 </v-container>
</template>

<script>
	import global from "../config/global"
	import approveRecord from "./approve_record.vue"
	import updateRecord from "./class_record_update.vue"
	import cancelApproveRecord from "./cancel_approve_record.vue"
	import recordBookSetting from "./record_book_setting.vue"
	import recordBookAddStudent from "./record_book_add_student.vue"
	import updateRecordBookPrice from "./update_record_book_price.vue"
	import updateApprovedRecordDetail from "./update_approved_record_detail.vue"
	export default {
		name:"record-info",
		components:{approveRecord,updateRecord,cancelApproveRecord,recordBookSetting,recordBookAddStudent,updateRecordBookPrice,updateApprovedRecordDetail},
		props: {
			//显示/隐藏。
			show: {
				type: Boolean,
				default: false
			},
			recordId:{
				type:String,
				default:null
			}
			
		},
		watch:{
			show(newVal,oldVal){
				console.log("newVal",newVal);
				this.hideShow = newVal;
				if(this.hideShow){
					this.normalStudentList = [];
					this.getRecordDetail();
				}
			}
		},
		data(){
			return {
				global:global,
				hideShow:this.show,
				record:null,
				normalStudentList:[],
				approveCom:{
					show:false,
					recordId:""
				},
				updateCom:{
					show:false,
					record:null
				},
				cancelApprove:{
					show:false,
					recordId:""
				},
				bookCom:{
					show:false,
					record:null
				},
				addBookStudent:{
					show:false,
					record:null
				},
				updateBookPrice:{
					show:false,
					bookStudent:null
				},
				updateRecordDialog:{
					show:false,
					recordDetail:null
				}
			}
		},
		mounted() {
			console.log("record-info-view mounted");
		},
		methods:{
			statusName(state) {
				let stName = "未知";
				if (state === "1") {
					stName = "待核销";
				} else if (state === "0") {
					stName = "已取消";
				}else if (state === "2") {
					stName = "已核销";
				}else if (state === "3") {
					stName = "已顺延";
				}
				return stName;
			},
			statusColor(state) {
				let color = "";
				if (state === "1") {
					color = "info";
				} else if (state === "0") {
					color = "error";
				}else if (state === "2") {
					color = "success";
				}else if (state === "3") {
					color = "grey";
				}
			
				return color;
			},
			cancel(){
				this.$emit("cancel","");
			},
			toShowApprove(){
				this.approveCom.recordId = this.recordId;
				this.approveCom.show = true;
			},
			toShowUpdate(){
				this.updateCom.record = this.record;
				this.updateCom.show = true;
			},
			approveSuccess(){
				this.getRecordDetail();
				this.approveCom.show= false;
				
			},
			updateSuccess(){
				this.getRecordDetail();
				this.updateCom.show = false;
			},
			showCancelApprove(){
				this.cancelApprove.recordId = this.recordId;
				this.cancelApprove.show = true;
			},
			cancelApproveSuccess(){
				this.getRecordDetail();
				this.cancelApprove.show = false;
			},
			frozenRecord(){
				// 取消排课记录
				const that = this;
				let url = `/edu/class/record/frozen/${this.record.id}`;
				this.axios.post(url).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("操作成功");
							that.getRecordDetail();
							return;
						}else{
							that.$noty.error("操作失败," + res.data["message"]);
							return;
						}
					} else {
						that.$noty.error('远程请求失败');
					}
				
				});
			},
			delayRecord(){
				// 顺延排课记录
				const that = this;
				let url = `/edu/class/record/delay/${this.record.id}`;
				this.axios.post(url).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("操作成功");
							that.getRecordDetail();
							return;
						}else{
							that.$noty.error("操作失败," + res.data["message"]);
							return;
						}
					} else {
						that.$noty.error('远程请求失败');
					}
				
				});
			},
			undoDelayRecord(){
				// 撤销顺延排课记录
				const that = this;
				let url = `/edu/class/record/delay/undo`;
				
				let postData = [this.record.id];
				this.axios.post(url,postData).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("操作成功");
							that.getRecordDetail();
							return;
						}else{
							that.$noty.error("操作失败," + res.data["message"]);
							return;
						}
					} else {
						that.$noty.error('远程请求失败');
					}
				
				});
			},
			getRecordDetail(){
			
				const recordId = this.recordId;
				// 获取校区学生列表
				if (!recordId) {
					return
				}
							
				const that = this;
				let url = `/edu/record/detail/` + recordId;
							
				this.axios.get(url).then(response => {
							
					if (response.data["code"] === 200) {
						let resData = response.data["data"] ? response.data["data"] : null;
						
						that.record = resData;
						
						console.log(resData);
					
						return
					}else{
						that.$noty.error("获取失败：" + response.data["message"]);
					}
							
					
				})
			},
			toShowBook(){
				// 开启约课
				console.log("open book");
				this.bookCom.show=true;
				this.bookCom.record = this.record;
			},
			showBatchRate(){
				// 批量点评
				
			},
			closeBook(){
				// 关闭约课
				console.log("close book");
			},
			bookSetSuccess(){
				// 约课设置成功
				this.getRecordDetail();
				this.bookCom.show = false;
			},
			showAddBookStudent(){
				this.addBookStudent.record = this.record;
				this.addBookStudent.show= true;
			},
			addBookStudentSuccess(){
				// 添加约课学员成功
				this.getRecordDetail();
				this.addBookStudent.show = false;
			},
			removeBookStudent(item){
				// 删除约课成员
				console.log(item);
				
	
				const that = this;
				let url = `/edu/record/book/student/remove/` + item.id;
							
				this.axios.post(url).then(response => {
							
					if (response.data["code"] === 200) {
						
						this.getRecordDetail();
					
						return
					}else{
						that.$noty.error("获取失败：" + response.data["message"]);
					}
							
					
				})
			},
			showUpdateBookPrice(item){
				
				if(this.record && this.record.approveConsumeType === "2"){
					this.updateBookPrice.bookStudent = item;
					this.updateBookPrice.show=true;
				}
				
			},
			updateBookPriceSuccess(e){
				this.getRecordDetail();
				this.updateBookPrice.show=false;
			},
			removeExtraStudent(item){
				// 删除补课学员
				console.log(item);
				const that = this;
				let url = `/edu/record/extra/student/remove/` + item.id;
							
				this.axios.post(url).then(response => {
							
					if (response.data["code"] === 200) {
						
						this.getRecordDetail();
					
						return
					}else{
						that.$noty.error("获取失败：" + response.data["message"]);
					}
							
					
				})
			},
			showUpdateRecord(item){
				console.log(item);
				this.updateRecordDialog.recordDetail = item;
				this.updateRecordDialog.show=true;
			},
			updateRecordSuccess(){
				this.updateRecordDialog.show = false;
				this.getRecordDetail();
			}
			
		}
	}
	
</script>

<style lang="scss" scoped src="../assets/styles/record-detail.scss"></style>
